import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from './ui';

/** "Copiază", then "Copiat" for two seconds. */
export function CopyButton({ text, label }: { text: string; label: string }) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }
  return (
    <Button variant="secondary" onClick={() => void copy()} aria-label={label}>
      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
      {copied ? 'Copiat' : 'Copiază'}
    </Button>
  );
}
